import Splide from '@splidejs/splide';

const slider1 = document.querySelector('#slider-one');
const slider2 = document.querySelector('#slider-two');
const slider3 = document.querySelector('#slider-three');
const slider4 = document.querySelector('#slider-four');

const breakpoints = {
  800: {
    perPage: 1,
    perMove: 1,
  },
  1036: {
    perPage: 2,
    perMove: 1,
  },
};

const classes = {
  prev: 'splide__arrow--prev jo-prev-arrow',
  next: 'splide__arrow--next jo-next-arrow',
  pagination: 'splide__pagination jo-pagination',
  page: 'splide__pagination__page jo-pagination-page',
};

const splide1 = new Splide(slider1, {
  perPage: 2,
  perMove: 1,
  classes,
  breakpoints,
});

const splide2 = new Splide(slider2, {
  perPage: 2,
  perMove: 1,
  classes,
  breakpoints,
});
const splide3 = new Splide(slider3, {
  perPage: 2,
  perMove: 1,
  classes,
  breakpoints,
});
const splide4 = new Splide(slider4, {
  perPage: 2,
  perMove: 1,
  classes,
  breakpoints,
});

splide1.mount();
splide2.mount();
splide3.mount();
splide4.mount();
